import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
/* eslint-disable @gandi/gandi/no-global-element */import * as React from 'react';
import { Link } from 'react-router';
import clsx from 'clsx';
import partition from 'lodash/partition';
import kebabCase from 'lodash/kebabCase';
var styles = {
  "truncate": "Navigation-truncate_17p5P",
  "root": "Navigation-root_3ofc8",
  "links": "Navigation-links_2Ocsn",
  "link": "Navigation-link_1aL2Y Navigation-truncate_17p5P",
  "main": "Navigation-main_1-2Zg",
  "widget": "Navigation-widget_LXJC0",
  "select": "Navigation-select_1pWLU is-block is-small"
};
function Navigation(_ref) {
  var items = _ref.items,
    isAuthenticated = _ref.isAuthenticated,
    locales = _ref.locales,
    currentLocale = _ref.currentLocale,
    className = _ref.className,
    onLinkClick = _ref.onLinkClick,
    onLocaleChange = _ref.onLocaleChange;
  var renderSelectors = function renderSelectors() {
    if (isAuthenticated) {
      return null;
    }
    return [Array.isArray(locales) && locales.length > 0 && /*#__PURE__*/React.createElement(SelectLocale, {
      key: "NavLocalesSelect",
      locales: locales,
      currentLocale: currentLocale,
      onChange: onLocaleChange
    })];
  };
  var rootClasses = clsx(styles.root, className);
  var _partition = partition(items, function (item) {
      return item.type && item.type === 'main';
    }),
    _partition2 = _slicedToArray(_partition, 2),
    mainItems = _partition2[0],
    restItems = _partition2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: rootClasses
  }, /*#__PURE__*/React.createElement(Nav, {
    onClick: onLinkClick,
    items: mainItems,
    className: styles.main
  }), /*#__PURE__*/React.createElement(Nav, {
    onClick: onLinkClick,
    items: restItems
  }), renderSelectors());
}
var Nav = function Nav(_ref2) {
  var items = _ref2.items,
    className = _ref2.className,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("nav", {
    className: className
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.links
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: "nav-".concat(kebabCase(item.title))
    }, item.to ? /*#__PURE__*/React.createElement(Link, {
      to: item.to,
      className: styles.link,
      onClick: onClick
    }, item.title) : /*#__PURE__*/React.createElement("a", {
      href: item.href,
      className: styles.link,
      onClick: onClick
    }, item.title));
  })));
};
var SelectLocale = function SelectLocale(_ref3) {
  var _ref3$locales = _ref3.locales,
    locales = _ref3$locales === void 0 ? [] : _ref3$locales,
    currentLocale = _ref3.currentLocale,
    onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.widget
  }, /*#__PURE__*/React.createElement("select", {
    onChange: onChange,
    className: styles.select,
    defaultValue: currentLocale
  }, locales.map(function (locale) {
    return /*#__PURE__*/React.createElement("option", {
      key: "locale-".concat(kebabCase(locale.name)),
      value: locale.code
    }, locale.name);
  })));
};
export default Navigation;